import post from './post';
import get from './get';

export { post, get };



// WEBPACK FOOTER //
// ./src/api/index.js